import _asyncToGenerator from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _regeneratorRuntime from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/regenerator";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { BadInputError, Result } from '@digibricks/core';
import { ErrorResultHandler } from '@lib/domain-common';
import { AxiosApi } from '@digibricks/plugin-axios';
import { EssayAnswer, SingleChoiceAnswer, MultipleChoiceAnswer, CreateAnswerResponse, AnswerType, FillInBlankGroupAnswer, Submission, SubmissionActivity, MatchingAnswerGroup, SpeakingAnswer } from '../../../core';
export var SUBMISSION_API = 'SUBMISSION_API';
export var SubmissionApi = /*#__PURE__*/function (_AxiosApi) {
  _inherits(SubmissionApi, _AxiosApi);

  var _super = _createSuper(SubmissionApi);

  function SubmissionApi(axiosInstance) {
    var _this;

    _classCallCheck(this, SubmissionApi);

    _this = _super.call(this, 'submissions', axiosInstance);
    _this.axiosInstance = axiosInstance;
    return _this;
  }

  _createClass(SubmissionApi, [{
    key: "getActivitiesById",
    value: function () {
      var _getActivitiesById = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(id) {
        var url, jsonResponse, parsedResponseBody;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.prev = 0;
                url = "".concat(this.url, "/").concat(id, "/activities");
                _context.next = 4;
                return this.axios.get(url);

              case 4:
                jsonResponse = _context.sent;
                parsedResponseBody = jsonResponse.data;
                return _context.abrupt("return", SubmissionActivity.fromJson(parsedResponseBody.data));

              case 9:
                _context.prev = 9;
                _context.t0 = _context["catch"](0);
                return _context.abrupt("return", ErrorResultHandler(_context.t0));

              case 12:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this, [[0, 9]]);
      }));

      function getActivitiesById(_x) {
        return _getActivitiesById.apply(this, arguments);
      }

      return getActivitiesById;
    }()
  }, {
    key: "getSubmissions",
    value: function () {
      var _getSubmissions = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(queryParams) {
        var jsonResponse, parsedResponseBody, submissions;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.prev = 0;
                _context2.next = 3;
                return this.axios.get(this.url, {
                  params: queryParams
                });

              case 3:
                jsonResponse = _context2.sent;
                parsedResponseBody = jsonResponse.data;
                submissions = parsedResponseBody.data.map(function (p) {
                  return Submission.fromJson(p).getValue();
                });
                return _context2.abrupt("return", Result.ok(submissions));

              case 9:
                _context2.prev = 9;
                _context2.t0 = _context2["catch"](0);
                return _context2.abrupt("return", ErrorResultHandler(_context2.t0));

              case 12:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this, [[0, 9]]);
      }));

      function getSubmissions(_x2) {
        return _getSubmissions.apply(this, arguments);
      }

      return getSubmissions;
    }()
  }, {
    key: "getById",
    value: function () {
      var _getById = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3(id) {
        var url, jsonResponse, parsedResponseBody;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _context3.prev = 0;
                url = "".concat(this.url, "/").concat(id);
                _context3.next = 4;
                return this.axios.get(url);

              case 4:
                jsonResponse = _context3.sent;
                parsedResponseBody = jsonResponse.data;
                return _context3.abrupt("return", Submission.fromJson(parsedResponseBody.data));

              case 9:
                _context3.prev = 9;
                _context3.t0 = _context3["catch"](0);
                return _context3.abrupt("return", ErrorResultHandler(_context3.t0));

              case 12:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[0, 9]]);
      }));

      function getById(_x3) {
        return _getById.apply(this, arguments);
      }

      return getById;
    }()
  }, {
    key: "grading",
    value: function () {
      var _grading = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(id) {
        var url, jsonResponse, parsedResponseBody, submissionSummary;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                _context4.prev = 0;
                url = "".concat(this.url, "/").concat(id, "/grading-submission");
                _context4.next = 4;
                return this.axios.patch(url);

              case 4:
                jsonResponse = _context4.sent;
                parsedResponseBody = jsonResponse.data;
                submissionSummary = Submission.fromJson(parsedResponseBody.data);
                return _context4.abrupt("return", submissionSummary);

              case 10:
                _context4.prev = 10;
                _context4.t0 = _context4["catch"](0);
                return _context4.abrupt("return", ErrorResultHandler(_context4.t0));

              case 13:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this, [[0, 10]]);
      }));

      function grading(_x4) {
        return _grading.apply(this, arguments);
      }

      return grading;
    }()
  }, {
    key: "update",
    value: function () {
      var _update = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(useCaseInput) {
        var _props, submission, input, submissionId, url;

        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _context5.prev = 0;
                submission = useCaseInput.submission, input = useCaseInput.input;
                submissionId = submission.id || ((_props = submission.props) === null || _props === void 0 ? void 0 : _props.id);
                url = "".concat(this.url, "/").concat(submissionId.toString());
                _context5.next = 6;
                return this.axios.patch(url, input);

              case 6:
                return _context5.abrupt("return", Result.ok());

              case 9:
                _context5.prev = 9;
                _context5.t0 = _context5["catch"](0);
                return _context5.abrupt("return", ErrorResultHandler(_context5.t0));

              case 12:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this, [[0, 9]]);
      }));

      function update(_x5) {
        return _update.apply(this, arguments);
      }

      return update;
    }()
  }, {
    key: "getAnswers",
    value: function () {
      var _getAnswers = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(useCaseInput) {
        var submissionId, _queryParams, url, jsonResponse, parsedResponseBody, resultCombine;

        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                _context6.prev = 0;
                submissionId = useCaseInput.submissionId, _queryParams = useCaseInput.queryParams;
                url = "".concat(this.url, "/").concat(submissionId, "/answers");
                _context6.next = 5;
                return this.axios.get(url, {
                  params: _queryParams,
                  headers: {
                    Authorization: "Bearer ".concat(localStorage.getItem('access_token'))
                  }
                });

              case 5:
                jsonResponse = _context6.sent;
                parsedResponseBody = jsonResponse.data;
                resultCombine = [];
                parsedResponseBody.data.forEach(function (answer) {
                  switch (answer.type) {
                    case AnswerType.Essay:
                      {
                        resultCombine.push(EssayAnswer.fromJson(answer));
                        break;
                      }

                    case AnswerType.SingleChoice:
                      {
                        resultCombine.push(SingleChoiceAnswer.fromJson(answer));
                        break;
                      }

                    case AnswerType.MultipleChoice:
                      {
                        resultCombine.push(MultipleChoiceAnswer.fromJson(answer));
                        break;
                      }

                    case AnswerType.Matching:
                      {
                        resultCombine.push(MatchingAnswerGroup.fromJson(answer));
                        break;
                      }

                    case AnswerType.FillInBlank:
                      {
                        resultCombine.push(FillInBlankGroupAnswer.fromJson(answer));
                        break;
                      }

                    case AnswerType.Speaking:
                      {
                        resultCombine.push(SpeakingAnswer.fromJson(answer));
                        break;
                      }

                    default:
                      {
                        return new BadInputError("Answer type: ".concat(answer.type, " does not support"));
                      }
                  }
                });
                return _context6.abrupt("return", Result.combineArray(resultCombine));

              case 12:
                _context6.prev = 12;
                _context6.t0 = _context6["catch"](0);
                return _context6.abrupt("return", ErrorResultHandler(_context6.t0));

              case 15:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this, [[0, 12]]);
      }));

      function getAnswers(_x6) {
        return _getAnswers.apply(this, arguments);
      }

      return getAnswers;
    }()
  }, {
    key: "createEssayAnswer",
    value: function () {
      var _createEssayAnswer = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(useCaseInput) {
        var submissionId, input, url, jsonResponse, parsedResponseBody;
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _context7.prev = 0;
                submissionId = useCaseInput.submissionId, input = useCaseInput.input;
                url = "".concat(this.url, "/").concat(submissionId, "/essay-answers");
                _context7.next = 5;
                return this.axios.post(url, input, {
                  headers: {
                    Authorization: "Bearer ".concat(localStorage.getItem('access_token'))
                  }
                });

              case 5:
                jsonResponse = _context7.sent;
                parsedResponseBody = jsonResponse.data;
                return _context7.abrupt("return", CreateAnswerResponse.create(parsedResponseBody.data));

              case 10:
                _context7.prev = 10;
                _context7.t0 = _context7["catch"](0);
                return _context7.abrupt("return", ErrorResultHandler(_context7.t0));

              case 13:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this, [[0, 10]]);
      }));

      function createEssayAnswer(_x7) {
        return _createEssayAnswer.apply(this, arguments);
      }

      return createEssayAnswer;
    }()
  }, {
    key: "updateEssayAnswer",
    value: function () {
      var _updateEssayAnswer = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(useCaseInput) {
        var submissionId, _id, input, url;

        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.prev = 0;
                submissionId = useCaseInput.submissionId, _id = useCaseInput.id, input = useCaseInput.input;
                url = "".concat(this.url, "/").concat(submissionId, "/essay-answers/").concat(_id);
                _context8.next = 5;
                return this.axios.patch(url, input);

              case 5:
                return _context8.abrupt("return", Result.ok());

              case 8:
                _context8.prev = 8;
                _context8.t0 = _context8["catch"](0);
                return _context8.abrupt("return", ErrorResultHandler(_context8.t0));

              case 11:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this, [[0, 8]]);
      }));

      function updateEssayAnswer(_x8) {
        return _updateEssayAnswer.apply(this, arguments);
      }

      return updateEssayAnswer;
    }()
  }, {
    key: "createSingleChoiceAnswer",
    value: function () {
      var _createSingleChoiceAnswer = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(useCaseInput) {
        var submissionId, input, url, jsonResponse, parsedResponseBody;
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                _context9.prev = 0;
                submissionId = useCaseInput.submissionId, input = useCaseInput.input;
                url = "".concat(this.url, "/").concat(submissionId, "/single-choice-answers");
                _context9.next = 5;
                return this.axios.post(url, input, {
                  headers: {
                    Authorization: "Bearer ".concat(localStorage.getItem('access_token'))
                  }
                });

              case 5:
                jsonResponse = _context9.sent;
                parsedResponseBody = jsonResponse.data;
                return _context9.abrupt("return", CreateAnswerResponse.create(parsedResponseBody.data));

              case 10:
                _context9.prev = 10;
                _context9.t0 = _context9["catch"](0);
                return _context9.abrupt("return", ErrorResultHandler(_context9.t0));

              case 13:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this, [[0, 10]]);
      }));

      function createSingleChoiceAnswer(_x9) {
        return _createSingleChoiceAnswer.apply(this, arguments);
      }

      return createSingleChoiceAnswer;
    }()
  }, {
    key: "updateSingleChoiceAnswer",
    value: function () {
      var _updateSingleChoiceAnswer = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10(useCaseInput) {
        var submissionId, _id2, input, url;

        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                _context10.prev = 0;
                submissionId = useCaseInput.submissionId, _id2 = useCaseInput.id, input = useCaseInput.input;
                url = "".concat(this.url, "/").concat(submissionId, "/single-choice-answers/").concat(_id2);
                _context10.next = 5;
                return this.axios.patch(url, input);

              case 5:
                return _context10.abrupt("return", Result.ok());

              case 8:
                _context10.prev = 8;
                _context10.t0 = _context10["catch"](0);
                return _context10.abrupt("return", ErrorResultHandler(_context10.t0));

              case 11:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, this, [[0, 8]]);
      }));

      function updateSingleChoiceAnswer(_x10) {
        return _updateSingleChoiceAnswer.apply(this, arguments);
      }

      return updateSingleChoiceAnswer;
    }()
  }, {
    key: "createMultipleChoiceAnswer",
    value: function () {
      var _createMultipleChoiceAnswer = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11(useCaseInput) {
        var submissionId, input, url, jsonResponse, parsedResponseBody;
        return _regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                _context11.prev = 0;
                submissionId = useCaseInput.submissionId, input = useCaseInput.input;
                url = "".concat(this.url, "/").concat(submissionId, "/multiple-choice-answers");
                _context11.next = 5;
                return this.axios.post(url, input, {
                  headers: {
                    Authorization: "Bearer ".concat(localStorage.getItem('access_token'))
                  }
                });

              case 5:
                jsonResponse = _context11.sent;
                parsedResponseBody = jsonResponse.data;
                return _context11.abrupt("return", CreateAnswerResponse.create(parsedResponseBody.data));

              case 10:
                _context11.prev = 10;
                _context11.t0 = _context11["catch"](0);
                return _context11.abrupt("return", ErrorResultHandler(_context11.t0));

              case 13:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, this, [[0, 10]]);
      }));

      function createMultipleChoiceAnswer(_x11) {
        return _createMultipleChoiceAnswer.apply(this, arguments);
      }

      return createMultipleChoiceAnswer;
    }()
  }, {
    key: "updateMultipleChoiceAnswer",
    value: function () {
      var _updateMultipleChoiceAnswer = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee12(useCaseInput) {
        var submissionId, _id3, input, url;

        return _regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                _context12.prev = 0;
                submissionId = useCaseInput.submissionId, _id3 = useCaseInput.id, input = useCaseInput.input;
                url = "".concat(this.url, "/").concat(submissionId, "/multiple-choice-answers/").concat(_id3);
                _context12.next = 5;
                return this.axios.patch(url, input);

              case 5:
                return _context12.abrupt("return", Result.ok());

              case 8:
                _context12.prev = 8;
                _context12.t0 = _context12["catch"](0);
                return _context12.abrupt("return", ErrorResultHandler(_context12.t0));

              case 11:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12, this, [[0, 8]]);
      }));

      function updateMultipleChoiceAnswer(_x12) {
        return _updateMultipleChoiceAnswer.apply(this, arguments);
      }

      return updateMultipleChoiceAnswer;
    }()
  }, {
    key: "createFillInBlankAnswer",
    value: function () {
      var _createFillInBlankAnswer = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee13(useCaseInput) {
        var submissionId, input, url, jsonResponse, parsedResponseBody;
        return _regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                _context13.prev = 0;
                submissionId = useCaseInput.submissionId, input = useCaseInput.input;
                url = "".concat(this.url, "/").concat(submissionId, "/fill-in-blank-answers");
                _context13.next = 5;
                return this.axios.post(url, input);

              case 5:
                jsonResponse = _context13.sent;
                parsedResponseBody = jsonResponse.data;
                return _context13.abrupt("return", CreateAnswerResponse.create(parsedResponseBody.data));

              case 10:
                _context13.prev = 10;
                _context13.t0 = _context13["catch"](0);
                return _context13.abrupt("return", ErrorResultHandler(_context13.t0));

              case 13:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13, this, [[0, 10]]);
      }));

      function createFillInBlankAnswer(_x13) {
        return _createFillInBlankAnswer.apply(this, arguments);
      }

      return createFillInBlankAnswer;
    }()
  }, {
    key: "updateFillInBlankAnswer",
    value: function () {
      var _updateFillInBlankAnswer = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee14(useCaseInput) {
        var submissionId, _id4, input, url;

        return _regeneratorRuntime.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                _context14.prev = 0;
                submissionId = useCaseInput.submissionId, _id4 = useCaseInput.id, input = useCaseInput.input;
                url = "".concat(this.url, "/").concat(submissionId, "/fill-in-blank-answers/").concat(_id4);
                _context14.next = 5;
                return this.axios.patch(url, input);

              case 5:
                return _context14.abrupt("return", Result.ok());

              case 8:
                _context14.prev = 8;
                _context14.t0 = _context14["catch"](0);
                return _context14.abrupt("return", ErrorResultHandler(_context14.t0));

              case 11:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee14, this, [[0, 8]]);
      }));

      function updateFillInBlankAnswer(_x14) {
        return _updateFillInBlankAnswer.apply(this, arguments);
      }

      return updateFillInBlankAnswer;
    }()
  }, {
    key: "createMatchingAnswer",
    value: function () {
      var _createMatchingAnswer = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee15(useCaseInput) {
        var submissionId, input, url, jsonResponse, parsedResponseBody;
        return _regeneratorRuntime.wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                _context15.prev = 0;
                submissionId = useCaseInput.submissionId, input = useCaseInput.input;
                url = "".concat(this.url, "/").concat(submissionId, "/matching-answers");
                _context15.next = 5;
                return this.axios.post(url, input);

              case 5:
                jsonResponse = _context15.sent;
                parsedResponseBody = jsonResponse.data;
                return _context15.abrupt("return", CreateAnswerResponse.create(parsedResponseBody.data));

              case 10:
                _context15.prev = 10;
                _context15.t0 = _context15["catch"](0);
                return _context15.abrupt("return", ErrorResultHandler(_context15.t0));

              case 13:
              case "end":
                return _context15.stop();
            }
          }
        }, _callee15, this, [[0, 10]]);
      }));

      function createMatchingAnswer(_x15) {
        return _createMatchingAnswer.apply(this, arguments);
      }

      return createMatchingAnswer;
    }()
  }, {
    key: "updateMatchingAnswer",
    value: function () {
      var _updateMatchingAnswer = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee16(useCaseInput) {
        var submissionId, _id5, input, url;

        return _regeneratorRuntime.wrap(function _callee16$(_context16) {
          while (1) {
            switch (_context16.prev = _context16.next) {
              case 0:
                _context16.prev = 0;
                submissionId = useCaseInput.submissionId, _id5 = useCaseInput.id, input = useCaseInput.input;
                url = "".concat(this.url, "/").concat(submissionId, "/matching-answers/").concat(_id5);
                _context16.next = 5;
                return this.axios.patch(url, input);

              case 5:
                return _context16.abrupt("return", Result.ok());

              case 8:
                _context16.prev = 8;
                _context16.t0 = _context16["catch"](0);
                return _context16.abrupt("return", ErrorResultHandler(_context16.t0));

              case 11:
              case "end":
                return _context16.stop();
            }
          }
        }, _callee16, this, [[0, 8]]);
      }));

      function updateMatchingAnswer(_x16) {
        return _updateMatchingAnswer.apply(this, arguments);
      }

      return updateMatchingAnswer;
    }()
  }, {
    key: "updateAnswer",
    value: function () {
      var _updateAnswer = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee17(useCaseInput) {
        var submissionId, _id6, input, url, jsonResponse, parsedResponseBody;

        return _regeneratorRuntime.wrap(function _callee17$(_context17) {
          while (1) {
            switch (_context17.prev = _context17.next) {
              case 0:
                _context17.prev = 0;
                submissionId = useCaseInput.submissionId, _id6 = useCaseInput.id, input = useCaseInput.input;
                url = "".concat(this.url, "/").concat(submissionId, "/answers/").concat(_id6);
                _context17.next = 5;
                return this.axios.patch(url, input);

              case 5:
                jsonResponse = _context17.sent;
                parsedResponseBody = jsonResponse.data;
                return _context17.abrupt("return", Submission.fromJson(parsedResponseBody.data));

              case 10:
                _context17.prev = 10;
                _context17.t0 = _context17["catch"](0);
                return _context17.abrupt("return", ErrorResultHandler(_context17.t0));

              case 13:
              case "end":
                return _context17.stop();
            }
          }
        }, _callee17, this, [[0, 10]]);
      }));

      function updateAnswer(_x17) {
        return _updateAnswer.apply(this, arguments);
      }

      return updateAnswer;
    }()
  }, {
    key: "getSubmissionsResponder",
    value: function () {
      var _getSubmissionsResponder = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee18(queryParams) {
        var jsonResponse, parsedResponseBody, submissionsResponder;
        return _regeneratorRuntime.wrap(function _callee18$(_context18) {
          while (1) {
            switch (_context18.prev = _context18.next) {
              case 0:
                _context18.prev = 0;
                _context18.next = 3;
                return this.axios.get(this.url, {
                  params: queryParams
                });

              case 3:
                jsonResponse = _context18.sent;
                parsedResponseBody = jsonResponse.data;
                submissionsResponder = parsedResponseBody.data.map(function (data) {
                  return Submission.fromJson(data);
                });
                return _context18.abrupt("return", Result.combineArray(submissionsResponder));

              case 9:
                _context18.prev = 9;
                _context18.t0 = _context18["catch"](0);
                return _context18.abrupt("return", ErrorResultHandler(_context18.t0));

              case 12:
              case "end":
                return _context18.stop();
            }
          }
        }, _callee18, this, [[0, 9]]);
      }));

      function getSubmissionsResponder(_x18) {
        return _getSubmissionsResponder.apply(this, arguments);
      }

      return getSubmissionsResponder;
    }()
  }, {
    key: "createAnswerComment",
    value: function () {
      var _createAnswerComment = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee19(useCaseInput) {
        var submissionId, _id7, commentId, submissionAnswerContent, commentContent, url;

        return _regeneratorRuntime.wrap(function _callee19$(_context19) {
          while (1) {
            switch (_context19.prev = _context19.next) {
              case 0:
                _context19.prev = 0;
                submissionId = useCaseInput.submissionId, _id7 = useCaseInput.id, commentId = useCaseInput.commentId, submissionAnswerContent = useCaseInput.submissionAnswerContent, commentContent = useCaseInput.commentContent;
                url = "".concat(this.url, "/").concat(submissionId, "/answers/").concat(_id7, "/comments");
                _context19.next = 5;
                return this.axios.post(url, {
                  commentId: commentId,
                  submissionAnswerContent: submissionAnswerContent,
                  commentContent: commentContent
                });

              case 5:
                return _context19.abrupt("return", Result.ok());

              case 8:
                _context19.prev = 8;
                _context19.t0 = _context19["catch"](0);
                return _context19.abrupt("return", ErrorResultHandler(_context19.t0));

              case 11:
              case "end":
                return _context19.stop();
            }
          }
        }, _callee19, this, [[0, 8]]);
      }));

      function createAnswerComment(_x19) {
        return _createAnswerComment.apply(this, arguments);
      }

      return createAnswerComment;
    }()
  }, {
    key: "updateAnswerComment",
    value: function () {
      var _updateAnswerComment = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee20(useCaseInput) {
        var submissionId, _id8, commentId, submissionAnswerContent, commentContent, url;

        return _regeneratorRuntime.wrap(function _callee20$(_context20) {
          while (1) {
            switch (_context20.prev = _context20.next) {
              case 0:
                _context20.prev = 0;
                submissionId = useCaseInput.submissionId, _id8 = useCaseInput.id, commentId = useCaseInput.commentId, submissionAnswerContent = useCaseInput.submissionAnswerContent, commentContent = useCaseInput.commentContent;
                url = "".concat(this.url, "/").concat(submissionId, "/answers/").concat(_id8, "/comments/").concat(commentId);
                _context20.next = 5;
                return this.axios.patch(url, {
                  submissionAnswerContent: submissionAnswerContent,
                  commentContent: commentContent
                });

              case 5:
                return _context20.abrupt("return", Result.ok());

              case 8:
                _context20.prev = 8;
                _context20.t0 = _context20["catch"](0);
                return _context20.abrupt("return", ErrorResultHandler(_context20.t0));

              case 11:
              case "end":
                return _context20.stop();
            }
          }
        }, _callee20, this, [[0, 8]]);
      }));

      function updateAnswerComment(_x20) {
        return _updateAnswerComment.apply(this, arguments);
      }

      return updateAnswerComment;
    }()
  }, {
    key: "deleteAnswerComment",
    value: function () {
      var _deleteAnswerComment = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee21(useCaseInput) {
        var submissionId, _id9, commentId, submissionAnswerContent, url;

        return _regeneratorRuntime.wrap(function _callee21$(_context21) {
          while (1) {
            switch (_context21.prev = _context21.next) {
              case 0:
                _context21.prev = 0;
                submissionId = useCaseInput.submissionId, _id9 = useCaseInput.id, commentId = useCaseInput.commentId, submissionAnswerContent = useCaseInput.submissionAnswerContent;
                url = "".concat(this.url, "/").concat(submissionId, "/answers/").concat(_id9, "/comments/").concat(commentId);
                _context21.next = 5;
                return this.axios["delete"](url, {
                  data: {
                    submissionAnswerContent: submissionAnswerContent
                  }
                });

              case 5:
                return _context21.abrupt("return", Result.ok());

              case 8:
                _context21.prev = 8;
                _context21.t0 = _context21["catch"](0);
                return _context21.abrupt("return", ErrorResultHandler(_context21.t0));

              case 11:
              case "end":
                return _context21.stop();
            }
          }
        }, _callee21, this, [[0, 8]]);
      }));

      function deleteAnswerComment(_x21) {
        return _deleteAnswerComment.apply(this, arguments);
      }

      return deleteAnswerComment;
    }()
  }, {
    key: "updateSpeakingAnswer",
    value: function () {
      var _updateSpeakingAnswer = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee22(useCaseInput) {
        var submissionId, answer, input, url, payload;
        return _regeneratorRuntime.wrap(function _callee22$(_context22) {
          while (1) {
            switch (_context22.prev = _context22.next) {
              case 0:
                _context22.prev = 0;
                submissionId = useCaseInput.submissionId, answer = useCaseInput.answer, input = useCaseInput.input;
                url = "".concat(this.url, "/").concat(submissionId, "/speaking-answers/").concat(answer.id.toString());
                payload = {
                  timestamp: input.timestamp || new Date().toISOString(),
                  value: input.value
                };
                _context22.next = 6;
                return this.axios.patch(url, payload);

              case 6:
                return _context22.abrupt("return", Result.ok());

              case 9:
                _context22.prev = 9;
                _context22.t0 = _context22["catch"](0);
                return _context22.abrupt("return", ErrorResultHandler(_context22.t0));

              case 12:
              case "end":
                return _context22.stop();
            }
          }
        }, _callee22, this, [[0, 9]]);
      }));

      function updateSpeakingAnswer(_x22) {
        return _updateSpeakingAnswer.apply(this, arguments);
      }

      return updateSpeakingAnswer;
    }()
  }, {
    key: "createSpeakingAnswerAttempt",
    value: function () {
      var _createSpeakingAnswerAttempt = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee23(useCaseInput) {
        var submissionId, answerId, url, jsonResponse, parsedResponseBody;
        return _regeneratorRuntime.wrap(function _callee23$(_context23) {
          while (1) {
            switch (_context23.prev = _context23.next) {
              case 0:
                _context23.prev = 0;
                submissionId = useCaseInput.submissionId, answerId = useCaseInput.answerId;
                url = "".concat(this.url, "/").concat(submissionId, "/speaking-answers/").concat(answerId, "/attempts");
                _context23.next = 5;
                return this.axios.post(url, {}, {
                  headers: {
                    Authorization: "Bearer ".concat(localStorage.getItem('access_token'))
                  }
                });

              case 5:
                jsonResponse = _context23.sent;
                parsedResponseBody = jsonResponse.data;
                return _context23.abrupt("return", Result.ok(parsedResponseBody.data));

              case 10:
                _context23.prev = 10;
                _context23.t0 = _context23["catch"](0);
                return _context23.abrupt("return", ErrorResultHandler(_context23.t0));

              case 13:
              case "end":
                return _context23.stop();
            }
          }
        }, _callee23, this, [[0, 10]]);
      }));

      function createSpeakingAnswerAttempt(_x23) {
        return _createSpeakingAnswerAttempt.apply(this, arguments);
      }

      return createSpeakingAnswerAttempt;
    }()
  }]);

  return SubmissionApi;
}(AxiosApi);